export default function ServiceCard({ icon, title, description, onClick }) {
  return (
    <article className="rounded-3xl border border-white/10 bg-white/10 p-7 text-center shadow-xl shadow-black/10 backdrop-blur transition hover:-translate-y-1 hover:bg-white/[0.14] hover:shadow-2xl">
      <div className="mb-5 flex justify-center text-cyan-300">{icon}</div>
      <h3 className="mb-3 text-xl font-bold text-white">{title}</h3>
      <p className="mb-6 text-slate-200">{description}</p>
      <button
        type="button"
        className="rounded-full bg-cyan-500 px-5 py-2.5 font-semibold text-white transition hover:bg-cyan-400"
        onClick={onClick}
      >
        Learn More
      </button>
    </article>
  );
}
